import React from 'react';
import {InfoIcon} from 'icons';

import './tooltip.scss';

export const Tooltip = ({text, children, layout, className}) => (
  <div className="tooltip-container">
    <div className={`tooltip ${className || ''}`} style={{flexDirection: layout}}>
      <InfoIcon />
      <div className="tooltip-text">{text}</div>
    </div>
    {children}
  </div>
);
